import { ScriptPosition, ScriptType } from '../types/featureFlags';

export const loadScript = (position: ScriptPosition, content: string, id: string, type: ScriptType): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (document.getElementById(id)) return resolve();

        const script = document.createElement('script');
        script.id = id;

        if (type === 'external') {
            script.src = content;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject();
        } else {
            script.text = content;
            resolve();
        }

        switch (position) {
            case 'head':
                document.head.appendChild(script);
                break;
            case 'bodyOpen':
                document.body.insertBefore(script, document.body.firstChild);
                break;
            case 'bodyClose':
                document.body.appendChild(script);
                break;
        }
    });
};

export const removeScript = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.remove();
};
